import React from 'react';
import { usePetAvailable } from './BaileyPet';
import { usePet, setPet } from './petStore';
import { hapticTick } from '../../../_utils/haptics';
import './BaileyPet.css';

/**
 * "Show Bailey" in the side menu, just above the profile. Hidden while the
 * welcome tour runs (it has its own Bailey).
 */
export default function BaileyPetToggle() {
  const { available, running } = usePetAvailable();
  const pet = usePet();
  if (!available || running) return null;
  const on = !!pet.visible;
  return (
    <button
      type="button"
      role="switch"
      aria-checked={on}
      className="bp-toggle"
      title={on ? 'Hide Bailey' : 'Show Bailey'}
      onClick={(e) => { e.stopPropagation(); hapticTick(); setPet({ visible: !on }); }}
    >
      <span className="bp-toggle-face" aria-hidden="true">
        <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
          <rect x="4" y="5" width="16" height="14" rx="5" />
          <circle cx="9.5" cy="12" r="1.4" fill="currentColor" stroke="none" />
          <circle cx="14.5" cy="12" r="1.4" fill="currentColor" stroke="none" />
        </svg>
      </span>
      <span className="bp-toggle-label">Show Bailey</span>
      <span className="bp-switch" aria-hidden="true" />
    </button>
  );
}
